export class Logger {
    // Created a new Logger instance with the given log path.
    // The log path is prepended to all log messages and needed to 
    // find logs for related components.
    constructor(logPath = '') {
        this.logPath = logPath;
        this.logPath = logPath;
    }
    // Created s child of a Logger instance with the given child path.
    // 
    // Example:
    // const logger = new Logger('parent');
    // const childLogger = logger.createChild('child');
    // logger.log('parent log');
    // childLogger.log('child log');
    // 
    // Output:
    // parent: parent log
    // parent/child: child log
    createChild(childPath) {
        return new Logger(this.logPath + '/' + childPath);
    }
    log(message, ...values) {
        values.length
            ? console.log(this.getPrefix(), message, values)
            : console.log(this.getPrefix(), message);
    }
    error(message, ...values) {
        values.length
            ? console.log(this.getPrefix(), message, values)
            : console.log(this.getPrefix(), message);
    }
    info(message, ...values) {
        values.length
            ? console.log(this.getPrefix(), message, values)
            : console.log(this.getPrefix(), message);
    }
    warn(message, ...values) {
        values.length
            ? console.log(this.getPrefix(), message, values)
            : console.log(this.getPrefix(), message);
    }
    debug(message, ...values) {
        values.length
            ? console.log(this.getPrefix(), message, values)
            : console.log(this.getPrefix(), message);
    }
    // Updated to include timestamp
    getPrefix() {
        const timestamp = this.getCurrentTimestamp();
        const pathPrefix = this.logPath ? `${this.logPath}:` : '';
        return `[${timestamp}] ${pathPrefix}`;
    }
    // Helper method to format the current timestamp
    getCurrentTimestamp() {
        const now = new Date();
        // Format: YYYY-MM-DD HH:MM:SS
        const date = now.toISOString().split('T')[0];
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
        return `${date} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    }
}
